import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const DynamicTabs = ({ tabs, styles, selectedIndex, handleSelect }) => {
  const renderTabs = () => {
    const tabTitles = [];

    const tabContents = tabs.map(tab => {
      tabTitles.push(<Tab className={`dynamic-tab_${tab.title}`} key={tab.title} style={styles} >{tab.title}</Tab>);
      return <TabPanel key={tab.title}>{tab.content}</TabPanel>;
    });

    return (
      <Tabs data-test="CacDynamicTabs" selectedIndex={selectedIndex} onSelect={handleSelect} >
        <TabList>{tabTitles}</TabList>
        {tabContents}
      </Tabs>
    );
  };

  return <div> {renderTabs()} </div>;
};

DynamicTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedIndex: PropTypes.number,
  handleSelect: PropTypes.func,
  styles: PropTypes.instanceOf(Object),
};

DynamicTabs.defaultProps = {
};

export default DynamicTabs;
